// extracted by mini-css-extract-plugin
export var layoutContainer = "_e0-0";
export var layoutContainerNoRounding = "_e0-6";
export var layoutContainerOpen = "_e0-5";
export var layoutContainerResizing = "_e0-1";
export var mainContent = "_e0-2";
export var resizeDivider = "_e0-3";
export var slidePanel = "_e0-4";